module Meevo.RequireClockIn {
    "use strict";

    export class RequireClockInContext {
        private selectedWorkActivityDetail: Model.DataDetail;
        private displayName: string;
        private isWorkActivityDisabled: boolean = false;

        constructor(
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: angular.translate.ITranslateService,
            private modalHandler: Function,
            private $window: angular.IWindowService,
            private $rootScope: angular.IRootScopeService

        ) {
            this.onInit();
            this.displayName = this.identityService.current().displayName
        }

        onInit(): void {
            let uri = `/api/TimeClock/${this.identityService.current().userId}/WorkTypes`;
            this.dataService.customMethodData(uri, "GET", null)
                .then(response => {
                    let workTypes = response.data.sort((data) => data.startDateTime)
                    this.getdefaultWorkType(workTypes).then((wt) => {
                        if (Model.Guard.isSomething(wt)) {
                            this.selectedWorkActivityDetail = { id: wt.id, displayName: wt.displayName };
                            this.isWorkActivityDisabled = true;
                        }
                    })
                })
        }

        private _workActivityCriteria = { workActivityCategoryEnumOnly: [Model.WorkActivityCategoryEnum.None] };
        get workActivityCriteria(): object {
            return this._workActivityCriteria;
        }

        getdefaultWorkType(workTypes: any): angular.IPromise<Model.DataDetail> {
            let currentTime = moment();
            return this.dataService.customMethodData('/api/Settings/ClockInOutRules', 'POST', {}).then((res: any) => {
                let settings = res.data as Model.ClockInOutRulesSettings;
                /*  If Too Early currentWorkType Will Be Null. Instead Return First Scheduled workType   */

                let currentWorkType = _.find(workTypes, (wt: any) => {
                    let startTime = moment(wt.startDateTime).subtract(settings.earlyClockInMinutes, 'minutes')
                    let endTime = moment(wt.endDateTime);
                    return startTime <= currentTime && endTime >= currentTime;
                }) || workTypes.reduce((min, current) =>
                    moment(current.startDateTime).isBefore(moment(min.startDateTime)) ? current : min
                );

                return currentWorkType
            })

        }

        redirect(): void {
            let state = this.identityService.isAuthProviderJcp ? Model.SessionState.LogOut : Model.SessionState.Lockout;
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.SESSION_TIMEOUT_HANDLER, state, 'RequireClockIn');
        }

        timePunch(): void {
            if (Model.Guard.isNothing(this.selectedWorkActivityDetail)) {
                this.modalService.alert('MESSAGE_CLOCKIN_REQUIRED_WORK_ACTIVITY', Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            let uri = `/api/TimeClock/Action`;
            let timeClockAction = {
                employeeId: this.identityService.current().userId,
                workTypeId: this.selectedWorkActivityDetail.id,
                clockTimeType: 0,
                clockTimeDirection: 0
            }

            this.modalHandler();

            this.dataService.customMethodData(uri, "POST", timeClockAction);
        }

    }
}